export enum ConfidenceToClose {
  Zero = 1,
  TwentyFive = 2,
  Fifty = 3,
  SeventyFive = 4,
  Hundred = 5
}

export enum ConfidenceToCloseNames {
  Zero = '0%',
  TwentyFive = '25%',
  Fifty = '50%',
  SeventyFive = '75%',
  Hundred = '100%',
}
